/* eslint-disable no-restricted-syntax */
// utils/constants.ts
// eslint-disable-next-line @typescript-eslint/typedef
export const AppRoutes = {
  DEFAULT: "", // 👈 empty route (useful for redirects)

  LOGIN: "login",
  REGISTRATION: "set-password",
  FORGET_PASSWORD: "forget-password",
  RESET_PASSWORD: "reset-password",
  SUCCESS: "success",

  DASHBOARD: "dashboard",
  DASHBOARD_CHILDREN: {
    CUSTOMER_LIST: "customer-list",
    XRAY_NEW: "x-ray-new",
    XRAY_LIST: "x-ray-list",
    XRAY_DETAIL_NEW: "x-ray-detail",
    BASIC_SETTING: "basic-setting",
    SUPPORT_SETTINGS: "support-settings",
  },
};
